import api from 'api'
import { WorkerRequirement } from 'api/typings'
import { pathOr } from 'ramda'

// NOTE: these types differ from the ones in common_defs.ts slightly
// since new position templates to groups are many-to-many
export interface PositionTemplateGroup {
  id: number
  name: string
}

export interface PositionTemplate {
  id: number
  name: string
  relevantPositionTemplateGroups: PositionTemplateGroup[]
  relevantPositionTemplateWorkerCategories: Array<{
    name: string
  }>
  requirements?: Array<{
    requirement: WorkerRequirement
    isPreSelected: boolean
    isWorkwhileRequired: boolean
  }>
}

export async function getPositionTemplates() {
  const data = await api.post(
    '/admin/graphql_dispatch/position_templates_c42b23e6',
    {}
  )

  const templates = pathOr(
    [],
    ['data', 'data', 'admin', 'positionTemplates'],
    data
  ) as PositionTemplate[]

  return templates.map((template) => ({
    ...template,
    id: Number(template.id),
  }))
}
